import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import '../../../Static/Master/firmtable.css';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { deleteSingleClothStock } from '../../../Store/PHPSlice/clothStock';
import { deleteManualStock } from '../../../Store/PHPSlice/Stock/StockApis';
import PreviewIcon from '@mui/icons-material/Preview';
import { Button } from '@mui/material';
import axios from 'axios';

const TableBodyItem = ({
    serialNumber,
    id,
    dt,
    dt2,
    icode,
    itemNm,
    bailno,
    pksts,
    sts,
    mclothNm,
    m1clothNm,
    m2clothNm,
    m3clothNm,
    item_clothNm,
    color,
    shadeNo,
    rack,
    locNm,
    size,
    qty,
    balqty,
    rate,
    trsts,
    totqty,
    qty_diff_sts,
    selected,
    handleClick,
}) => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const userdata = JSON.parse(localStorage.getItem('user'));
    const dispatch = useDispatch();
    // const getDelete = useSelector((state) => state.companyData.deleteComp);
    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open

        window.open(`/manual-stk-edit/${id}`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };
    const userId = '1';

    const handleDeleteClick = () => {
        // Show confirmation dialog

        deleteManStkItem(id);

    };

    const deleteManStkItem = async (id) => {

        try {
            const res = await axios.delete(`${baseUrl}?apicall=deleteManualStock&mstkId=${id}`);
            console.log(res);
            const data = res?.data;
            if (data?.status === "success") {
                alert(data.msg);
                window.location.reload();
            } else {
                if (Array.isArray(data?.msg)) {
                    alert(data.msg.join("\n"));
                } else if (typeof data?.msg === "string") {
                    alert(data.msg);
                }
            }
        } catch (error) {
            console.error("Error deleting Item:", error);
        }
    };

    var itemName = itemNm;
    if (mclothNm !== '') {
        itemName = `${itemNm} - ${mclothNm}`;
    }
    if (m1clothNm !== '') {
        itemName = `${itemNm} - ${mclothNm}, ${m1clothNm}`;
    }
    if (m2clothNm !== '') {
        itemName = `${itemNm} - ${mclothNm}, ${m1clothNm}, ${m2clothNm}`;
    }
    if (m3clothNm !== '') {
        itemName = `${itemNm} - ${mclothNm}, ${m1clothNm}, ${m2clothNm}, ${m3clothNm}`;
    }

    const handleViewClick = () => {
        window.open(`/manual-stk-view/${id}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };
    const handleBarcodeViewClick = () => { 
         window.open(`/manual-stk-view-barcode/${id}/0`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };

    const handleTransferClick = () => {
        // Replace 'URL' with the actual URL you want to open

        window.open(`/manual-stk-transfer/${id}`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };
    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {serialNumber}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {dt}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {itemNm}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {mclothNm}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {bailno === '' ? '-' : bailno}
                </TableCell>

                {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {color}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {shadeNo}
                </TableCell> */}

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {rack}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {locNm === '0' ? '-' : locNm}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {totqty}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <PreviewIcon onClick={handleViewClick} className='cursor-pointer' />
                </TableCell>
             

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <EditIcon className={`cursor-pointer `} onClick={handleEditClick} />
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <DeleteIcon className={`cursor-pointer ${qty_diff_sts == 1 ? 'disabled-icon' : ''}`} onClick={handleDeleteClick} />
                </TableCell>


            </TableRow>
        </>
    );
};

export default React.memo(TableBodyItem);
